import React from 'react';
import SvgIcons from 'app/blocks/common/svg-icon/svg-icon';
import './fundingInformation.scss';

type Props = {
    icon: keyof typeof SvgIcons;
    label: string;
    value: React.ReactNode;
    seleniumid: string;
};

function FundingInformation({ icon, label, seleniumid, value }: Props) {
    const Icon = SvgIcons[icon];
    return (
        <div className="fundingInfoRow">
            <div className="fundingInfoRow-Icon">
                <Icon aria-label={label} iconTitle={label} role="img" />
            </div>
            <div className="fundingInfoRow-Content">
                <div className="fundingInfoRow-Label" data-seleniumid={`${seleniumid}-label`}>
                    {label}
                </div>
                <div className="fundingInfoRow-Value" data-seleniumid={seleniumid}>
                    {value}
                </div>
            </div>
        </div>
    );
}

export default FundingInformation;
